// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--mGLHS","title":"a10a3f92e9--title--LuVj_","link":"a10a3f92e9--link--oPguz"};